import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// index page sections
import Download from "../sub_components/Download.js";

import { MultiLang, Determinator } from "react-multi-language";
import Navbar from "components_/sub_components/Navbar.js";

import "video-react/dist/video-react.css";
import { Player, BigPlayButton } from 'video-react';

class Innovations extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // itemsToShow: 3,
      expanded: false,
    };
    this.showMore = this.showMore.bind(this);
  }

  showMore() {
    // this.state.itemsToShow === 3 ? (
    //   this.setState({ itemsToShow: 5, expanded: true })
    // ) : (
    //     this.setState({ itemsToShow: 3, expanded: false })
    //   )
    this.setState({ expanded: !this.state.expanded })
  }

  state = {};
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
    console.log("..[log - Innovations.js (componentDidMount()), languageState] : ", this.props.languageState);
    console.log(this.props.languageState);
  };

  render() {
    return (
      <>
        <Navbar languageState={this.props.languageState} updateLanguageState={this.props.updateLanguageState} />
        {console.log("..[log - Innovations.js, languageState] : ", this.props.languageState)}
        {/* <DemoNavbar /> */}
        <main ref="main">
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="6">
                      <h1 className="display-3 text-white">
                        {/* Recent Activities{" "} */}
                        <Determinator>
                          {{
                            en: "Innovations",
                            tw: "創新科技",
                            cn: "创新科技",
                          }}
                        </Determinator>
                        {" "}
                        {/* <span>completed with examples</span> */}
                      </h1>
                      {/* <button onClick={() => { this.props.updateLanguageState({ lang: "param" }) }}>road to success</button> */}
                      {/* <p className="lead text-white">
                        <Determinator>
                          {{
                            en: "Upcoming Events ",
                            tw: "近期活動",
                            cn: "近期活动",
                          }}
                        </Determinator>
                      </p> */}
                      {/* <div className="btn-wrapper">
                        <Button
                          className="btn-icon mb-3 mb-sm-0"
                          color="info"
                          href="https://demos.creative-tim.com/argon-design-system-react/#/documentation/alerts?ref=adsr-landing-page"
                        >
                          <span className="btn-inner--icon mr-1">
                            <i className="fa fa-code" />
                          </span>
                          <span className="btn-inner--text">Components</span>
                        </Button>
                        <Button
                          className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                          color="default"
                          href="https://www.creative-tim.com/product/argon-design-system-react?ref=adsr-landing-page"
                        >
                          <span className="btn-inner--icon mr-1">
                            <i className="ni ni-cloud-download-95" />
                          </span>
                          <span className="btn-inner--text">
                            Download React
                          </span>
                        </Button>
                      </div> */}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>

          <section className="section text-align-justify">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "Site Specific 5G Network ",
                      tw: "地盤專用5G網絡",
                      cn: "地盘专用5G网络",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <div className="">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/innovations/5g_01.jpg")}
                      top
                    />
                  </div>
                </Col>
                <Col md="6">
                  <div className="">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/innovations/5g_02.jpg")}
                      top
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    {/* <h3>
                      <Determinator>
                        {{
                          en: "Groundbreaking Ceremony",
                          tw: "動土儀式",
                          cn: "动土仪式",
                        }}
                      </Determinator>
                    </h3> */}
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "Our Project: “Relocation of Sha Tin Sewage Treatment Works to Caverns”, is the first construction site in Hong Kong to establish a site specific 5G network in tunnel under construction.",
                          tw: "搬遷沙田污水處理廠往岩洞工程為全港率先於在建的隧道內，建立專用5G網絡的基建工程項目。",
                          cn: "搬迁沙田污水处理厂往岩洞工程为全港率先於在建的隧道内，建立专用5G网络的基建工程项目。",
                        }}
                      </Determinator>                  

                      {this.state.expanded ? (
                        <div>
                        <br />                        
                        <Determinator>
                          {{
                            en: "In order to break through the restriction of confined space environment in tunnel works to implement innovative technologies, the construction team brought in a site-specific 5G base station. With the advantages from 5G network of low latency, high-speed transmission, and high device capacity, together with the development and implementation of various innovative technologies, we can improve the efficiency of project management, construction safety and site progress monitoring. We can also accumulate large amount of valuable data for the future development of cavern projects in Hong Kong.",
                            tw: "為了創新科技在地盤的應用可以突破隧道密閉空間的限制，工程團隊引入地盤專屬的5G基站，利用5G網絡低延誤、高速傳輸、同時處理大量數據的優點，配合大量創新科技的研發及使用，不僅能提升工程管理效率、施工安全及進度，更能為本港岩洞工程的發展累積大量寶貴的數據。",
                            cn: "为了创新科技在地盘的应用可以突破隧道密闭空间的限制，工程团队引入地盘专属的5G基站，利用5G网络低延误丶高速传输丶同时处理大量数据的优点，配合大量创新科技的研发及使用，不仅能提升工程管理效率丶施工安全及进度，更能为本港岩洞工程的发展累积大量宝贵的数据。",
                          }}
                        </Determinator>
                        <br />  
                        <br />                       
                        <Determinator>
                          {{
                            en: "Our site is located in Ma On Shan, where 3.5GHz spectrum is solely for aircraft satellite channel. However, 3.5GHz is the common spectrum for 5G network. Therefore, we chose 4.9GHz spectrum to create a unique 5G network in Ma On Shan. Thanks to this site specific 5G network, the construction team can use the digitalized systems freely without the restriction of location and network speed, e.g. the DWSS system, Measure-While-Drilling system even 200m length inside tunnel, RFID system, electronic document management system and 3D Scanning, etc. It allows site staff to send and receive large amount of real time construction information at different locations, strengthens connection, avoids complicated paperwork, and achieves the goal of paperless office.",
                            tw: "本工程所在的馬鞍山區，處於飛機衛星航道，屬於頻譜3.5GHz禁制區域，而3.5GHz為5G常用的頻譜。因此，本工程特別選擇了4.9GHz頻譜，打造了馬鞍山區獨有的5G網絡。工程團隊可以不受地域及網絡流量、速度的限制，廣泛應用流動數碼管理系統(DWSS)，即使深入隧道二百多尺，亦可以使用隨鑽測量（Measure-While-Drilling）、頻識別技術(RFID)、電子文件管理系統及三維掃瞄(3D Scanning)等，讓不同崗位的同事發放及接收大量實時工程訊息，加強聯繫之餘，亦免卻繁複的文書工作，實現無紙化實時辦公目標。",
                            cn: "本工程所在的马鞍山区，处於飞机卫星航道，属於频谱3.5GHz禁制区域，而3.5GHz为5G常用的频谱。因此，本工程特别选择了4.9GHz频谱，打造了马鞍山区独有的5G网络。工程团队可以不受地域及网络流量丶速度的限制，广泛应用流动数码管理系统(DWSS)，即使深入隧道二百多尺，亦可以使用随钻测量（Measure-While-Drilling）丶频识别技术(RFID)丶电子文件管理系统及三维扫瞄(3D Scanning)等，让不同岗位的同事发放及接收大量实时工程讯息，加强联系之馀，亦免却繁复的文书工作，实现无纸化实时办公目标。",
                          }}
                        </Determinator>
                        <br />           
                        <br />              
                        <Determinator>
                          {{
                            en: "The blasting process monitoring apps solely developed by the construction team helps collecting real-time data of the blasting process for comparison and analysis, so as to optimize each process. When combined with the application of BIM, 5G network can help strengthen the performance of BIM, improve the constructability of construction projects, and save time and costs. Engineers can immediately grasp the actual situation in the tunnel, and then adjust the design and planning.",
                            tw: "其中工程團隊原創研發的爆破工序監察應用程式更協助團隊收集大量爆破工序的相關數據，供對比及分析，以便優化每項工序。配合建築信息模擬(BIM)時，5G有助強化BIM的表現，提升建築項目的可建造性，及節省時間與成本。工程師可以即時掌握隧道內實況，再調整設計及規劃。",
                            cn: "其中工程团队原创研发的爆破工序监察应用程式更协助团队收集大量爆破工序的相关数据，供对比及分析，以便优化每项工序。配合建筑信息模拟(BIM)时，5G有助强化BIM的表现，提升建筑项目的可建造性，及节省时间与成本。工程师可以即时掌握隧道内实况，再调整设计及规划。",
                          }}
                        </Determinator>
                        <br />   
                        <br />                      
                        <Determinator>
                          {{
                            en: "The high efficiency of 5G network also helps to monitor the real-time conditions of the tunnel. For example, immediately after blasting, an automated guided robotic car can go inside the tunnel to instantly transmit a full range of real-time high-definition images, to ensure tunnel safety before workers to enter into it. Furthermore, the real-time air monitoring device and UWB positioning watch are used separately to monitor the air, temperature, luminosity, gas and the health status of workers in the tunnel, as well as the safety of the location. In case of danger, an alarm will be issued immediately. It greatly improves construction efficiency and ensures the safety of workers.",
                            tw: "高效網絡還有助監察隧道實時情況。如爆破後又可以利用無人駕駛的智能機械車即時傳送隧道內的全方位實時高清景像，確保環境安全才讓工友進入施工。加上智能氣體監察裝置及UWB定位手錶分別監察隧道內空氣、溫度、光度、氣體和工友健康狀況、施工位置安全情況，遇有危險情況又會即時發出警號。相輔相成下，不但大大提高了工程效率，還更加保障工友安全。",
                            cn: "高效网络还有助监察隧道实时情况。如爆破後又可以利用无人驾驶的智能机械车即时传送隧道内的全方位实时高清景像，确保环境安全才让工友进入施工。加上智能气体监察装置及UWB定位手表分别监察隧道内空气丶温度丶光度丶气体和工友健康状况丶施工位置安全情况，遇有危险情况又会即时发出警号。相辅相成下，不但大大提高了工程效率，还更加保障工友安全。",
                          }}
                        </Determinator>
                        <br />        
                        <br />                 
                        <Determinator>
                          {{
                            en: "As the project heats up and the construction site is deeper into the mountain, more blasting works will be implemented for cavern in the future. More innovative technologies are required to improve the construction management and ensure the safety of workers. In the future, there will be higher requirements for volume of data, the transmission speed and frequency. A stable and efficient 5G network is indeed an indispensable part of a safe and efficient construction site.",
                            tw: "隨着工程白熱化，施工位置更深入山腹，未來岩洞會於多個炮面進行爆破，屆時需要更多創新科技來提高管理及保障工友安全。將來於數據量、傳輸速度及頻率上亦有更高要求，穩定及高效率的5G網絡實在是安全高效施工不可或缺的一個環節。",
                            cn: "随着工程白热化，施工位置更深入山腹，未来岩洞会於多个炮面进行爆破，届时需要更多创新科技来提高管理及保障工友安全。将来於数据量丶传输速度及频率上亦有更高要求，稳定及高效率的5G网络实在是安全高效施工不可或缺的一个环节。",
                          }}
                        </Determinator>
                          
                        </div>
                        ) : (
                            <br />
                          )
                      }
                    </p>

                    <br />
                      <div className="text-align-center">
                        <a href="#" className="text-grey" onClick={this.showMore}>
                          {this.state.expanded ? (
                            <div>
                              ⇡
                            </div>
                          ) : (
                              <div>
                                <Determinator>
                                  {{
                                    en: "show more",
                                    tw: "展開閱讀",
                                    cn: "展开阅读",
                                  }}
                                </Determinator>
                              </div>
                            )
                          }
                        </a>
                      </div>
                    <br />

                    {/* <p>
                      <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator>
                    </p> */}
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="bg-secondary section text-align-justify">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "BIM ",
                      tw: "BIM 建築信息模擬",
                      cn: "BIM 建筑信息模拟",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <Player
                      autoplay
                      // playsInline
                      poster={require("assets_/img_/innovations/bim_photo.jpg")}
                      src={require("assets_/img_/innovations/clc_guide.mp4")}
                    >
                      {/* <source src={require("assets_/img_/innovations/clc_guide.mp4")} /> */}
                      <BigPlayButton position="center" />
                    </Player>
                    {/* <CardImg
                      alt="..."
                      src={require("assets_/img_/innovations/bim_photo.jpg")}
                      top
                    /> */}
                    {/* <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Volunteer Work
                      </h4>
                      <p className="lead text-italic text-white">
                        Volunteer team contributes to the society in every summer.
                      </p>
                    </blockquote> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/innovations/bim_photo_02.jpg")}
                      top
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    {/* <h3>
                      <Determinator>
                        {{
                          en: "Groundbreaking Ceremony",
                          tw: "動土儀式",
                          cn: "动土仪式",
                        }}
                      </Determinator>
                    </h3> */}
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "A BIM model was created before the construction commencement. This enables us to visualise the design and allow easier construction.",
                          tw: "正式施工前，我們先建立一套建築信息模擬。這樣可以將設計形象化， 從而令施工過程中的溝通變得更輕鬆有效。",
                          cn: "正式施工前，我们先建立一套建筑信息模拟。这样可以将设计形象化， 从而令施工过程中的沟通变得更轻松有效。",
                        }}
                      </Determinator>
                    </p>
                    {/* <p>
                      <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator>
                    </p> */}
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section text-align-justify">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "MiC",
                      tw: "組裝合成建築法",
                      cn: "组装合成建筑法",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/innovations/mic_photo.jpg")}
                      top
                    />
                    {/* <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Volunteer Work
                      </h4>
                      <p className="lead text-italic text-white">
                        Volunteer team contributes to the society in every summer.
                      </p>
                    </blockquote> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    {/* <h3>
                      <Determinator>
                        {{
                          en: "Groundbreaking Ceremony",
                          tw: "動土儀式",
                          cn: "动土仪式",
                        }}
                      </Determinator>
                    </h3> */}
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "The CLC is constructed by Modular integrated Construction (MiC) method to reduce construction time and space required. CLC was divided into 14 modules, each one was prefabricated in factory with most interior finishes installed and then transported on site for final construction.",
                          tw: "為了減少所需的構造時間和空間, 本社區聯絡中心使用了組裝合成建築法(MiC) 建造。本中心共分為14個預製「組裝合成」組件，每個組件在出廠時已完成了室內裝修, 以供運送到工地完成裝嵌。",
                          cn: "为了减少所需的构造时间和空间, 本社区联络中心使用了组装合成建筑法(MiC) 建造。本中心共分为14个预制「组装合成」组件，每个组件在出厂时已完成了室内装修, 以供运送到工地完成装嵌。",
                        }}
                      </Determinator>
                    </p>
                    {/* <p>
                      <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator>
                    </p> */}
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="bg-secondary section text-align-justify">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "CAVE ",
                      tw: "沉浸式電腦虛擬環境",
                      cn: "沉浸式电脑虚拟环境",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/innovations/cave_photo.jpg")}
                      top
                    />
                    {/* <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Volunteer Work
                      </h4>
                      <p className="lead text-italic text-white">
                        Volunteer team contributes to the society in every summer.
                      </p>
                    </blockquote> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    {/* <h3>
                      <Determinator>
                        {{
                          en: "Groundbreaking Ceremony",
                          tw: "動土儀式",
                          cn: "动土仪式",
                        }}
                      </Determinator>
                    </h3> */}
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "The Computer Assisted Virtual Reality (CAVE) System provide an immersive 3D Virtual Reality (VR) Environment for visitor to experience the construction environment with near-reality spatial sense. The CAVE also gives visitors to participate in our VR safety training to understand our dedication to safety.",
                          tw: "電腦輔助虛擬實景（CAVE）系統為中心訪客提供身臨其境的3D虛擬實景（VR），以接近現實的空間感體驗工地現場環境。 CAVE還為訪客提供了參加VR安全培訓的機會，直此了解我們對安全的重視。",
                          cn: "电脑辅助虚拟实景（CAVE）系统为中心访客提供身临其境的3D虚拟实景（VR），以接近现实的空间感体验工地现场环境。 CAVE还为访客提供了参加VR安全培训的机会，直此了解我们对安全的重视。",
                        }}
                      </Determinator>
                    </p>
                    {/* <p>
                      <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator>
                    </p> */}
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section text-align-justify">
            <Container>
              <Row className="row-grid align-items-center">
                <h1 className="display-3">
                  <Determinator>
                    {{
                      en: "Construction 3D Printing ",
                      tw: "三維打印建築技術",
                      cn: "三维打印建筑技术",
                    }}
                  </Determinator>
                  {" "}
                  {/* <span>completed with examples</span> */}
                </h1>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/innovations/3d_printing_photo.jpg")}
                      top
                    />
                    {/* <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Volunteer Work
                      </h4>
                      <p className="lead text-italic text-white">
                        Volunteer team contributes to the society in every summer.
                      </p>
                    </blockquote> */}
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}
                    {/* <h3>
                      <Determinator>
                        {{
                          en: "Construction 3D printing ",
                          tw: "三維打印建築技術",
                          cn: "三维打印建筑技术",
                        }}
                      </Determinator>
                    </h3> */}
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "To try out and demonstrate the state-of-the-art construction technology, the wall in the conference room is constructed by 3D printing method. 3D printing technology enable us to realise the pattern which is difficult to be constructed in traditional method, with less wastage.",
                          tw: "為展示最新的施工技術，我們使用了3D打印技術建造本中心會議室的其中一面牆身。 3D打印技術能夠輕易製造傳統方法難以建造的形狀/圖案，並且減少物料浪費。",
                          cn: "为展示最新的施工技术，我们使用了3D打印技术建造本中心会议室的其中一面墙身。 3D打印技术能够轻易制造传统方法难以建造的形状/图案，并且减少物料浪费。",
                        }}
                      </Determinator>
                    </p>
                    {/* <p>
                      <Determinator>
                        {{
                          en: "CLC Groundbreaking Ceremony",
                          tw: "社區聯絡中心動土儀式",
                          cn: "社区联络中心动土仪式",
                        }}
                      </Determinator>
                    </p> */}
                    {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                    {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

        </main>
        <MultiLang lang={this.props.languageState.lang} />

      </>
    );
  }
}

export default Innovations;
